import { httpClient } from '@/infra/protocols/http';

export namespace DeleteScriptService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
    blockId: number;
  }
  export type Response = { message: string };
}

export async function deleteScript(
  params: DeleteScriptService.Params,
): Promise<DeleteScriptService.Response> {
  const response = await httpClient.delete<{ mensagem: string }>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/roteiro/blocos/${params.blockId}`,
  );

  return { message: response.mensagem };
}
